module.exports = __webpack_public_path__ + "img/pr-13.31554b4f.png";